// Datos de contacto en un solo lugar (los usan Contacto y Footer).
export const EMAIL = 'info@saviasacr.com';
export const WHATSAPP_URL = 'https://wa.me/50683505275';
export const PHONE_MAIN = '8350-5275'; // abre WhatsApp
export const PHONE_ALT = { label: '8696-8913', href: 'tel:+50686968913' }; // abre llamada
